<template lang="pug">
base-view.page
	router-view
</template>

<script>
import BaseView from "@/views/BaseView";
import Component from "vue-class-component";

@Component
class DmsRouteView extends BaseView {}

export default DmsRouteView;
</script>
